const initialvalues = {
    svamitvapropertydetails: {},
};


export default function SvamitvaReducer(details = initialvalues, action) {
    switch (action.type) {
        case "SVAMITVAPROPERTYDETAILS":
            return { ...details, svamitvapropertydetails: action.payload };
        default:
            return details;
    }
}
 